<template>
  <div id="app">
      <div v-if="$store.state.loading==true" style="z-index:9999;position:relative" class="my-auto">
      <loading
        :active.sync="$store.state.loading"
        background-color="#9b9999"
        color="#2c80ff"
        loader="dots"
        transition="fade"
        height="150"
        width="150"
        is-full-page
      ></loading>
    </div>
    
    <Nav style="z-index:1500" v-if="$router.currentRoute.path!=='/login' && $cookies.get('address')"></Nav>
     
   <div style="" class="body">
      <vue-page-transition name="fade-in-up">
       
    
        <keep-alive :exclude='["LoginView","AdminView"]'>
          
          <router-view   style="z-index:999;" :key="$route.fullPath"/>
        
        </keep-alive>
       
      </vue-page-transition>
       
  </div>
       

  
      <particlesJS v-if="$router.currentRoute.path!='/login' &&  $cookies.get('address')"></particlesJS>

      
  
   
  </div>
</template>
<script>
import Nav from "./components/Nav";
import particlesJS from "./views/particlesJS";


export default {
  data() {
    return {
      currentAddress:this.$cookies.get('address'),
      wallet:localStorage.wallet,
      wallet_web3:localStorage.wallet_web3,
      loggedIn: false,
      navAddress:undefined
    };
  },

 
  
  
  components: {
    Nav,
    particlesJS
  },

  methods: {
    async getCurrentAccount() {
      // this.currentAccount = acc[0];
      let account = await window.web3.eth.getAccounts();
      this.currentAccount = account[0];
      window.ethereum.on("accountsChanged", function() {
       // window.location.reload();
        // Time to reload your interface with accounts[0]!
      });
      // let time=setInterval(async function(){
      //       let newAccount = await window.web3.eth.getAccounts();
      //       if(this.currentAccount!=newAccount[0]){
      //          window.location.reload();
      //       }
      // })
      // await time()

      // Time to reload your interface with accounts[0]!
    },
    async getNetwork() {
      // await this.$store.dispatch("getLogin");
      // console.log(this.$store.state.loggedIn);

      if (window.web3 != undefined) {
        //  let network = await window.web3.eth.net.getNetworkType();
        let address = await window.web3.eth.getAccounts();

        if (address[0] !== "" && address[0] !== undefined) {
          this.loggedIn = true;
          //this.$store.state.loggedIn = true;
        }
      }
      // }
    }
  },
  updated(){
   
 

  },
  async mounted() {
   
      this.$store.dispatch('setContract')
      
   
    // const plugin1 = document.createElement("script");
    // plugin1.setAttribute("src", "/js/jquery.bundle.js?ver=104");
    // plugin1.async = true;
    // document.head.appendChild(plugin1);
   
    // const plugin2 = document.createElement("script");
    // plugin2.setAttribute("src", "/js/script.min.js?ver=104");
    // plugin2.async = true;
    // document.head.appendChild(plugin2);
    
    
  },
  async created() {
    
    //await this.getCurrentAccount();
    
   
    await this.$store.dispatch(
      "getCurrentBalance",
      this.currentAddress
    );
  }
};
</script>

<style>
@import "./assets/css/style.css";
@import "./assets/css/vendor.bundle.css?ver=104";
@import "./assets/css/style.css?ver=104";
@import url('https://fonts.googleapis.com/css?family=Work+Sans:300,400,500,600,700:100,300,400,500,700,900&display=swap');
#app {
  font-family: 'Work Sans', sans-serif;;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-bottom: 0;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

#particles-js {
  position: fixed;
  top: 0;
  width: 100%;
  height: 100vh;
  left: 0;
  z-index: -99;
}

.style {
  padding: 15px;
  width: 50%;
  text-align:center;
}
</style>
